import { Box } from "@mui/material";
import ImageBackgroundWithCarousel from "./imageBackgroundWithCarousel";
import { CustomDiv, InlineDiv } from "@/common/divs";
import { ActivityDetailGeoSearch } from "@/model";
import { NEUTRO_TITLES_COLOR } from "@/utils/constants";

const ActivityMobileHeader = ({
  activity,
}: {
  activity: ActivityDetailGeoSearch;
}) => {
  const filteredImages =
    activity.images?.filter((activity) => activity.type !== "BANNER") ?? [];

  return (
    <>
      <CustomDiv width="100%" height="auto" paddingX="0px">
        <InlineDiv
          className="activity-header-content"
          width="100%"
          style={{ gap: "20px" }}
        >
          {activity.images && (
            <Box sx={{ background: NEUTRO_TITLES_COLOR, width: "100%" }}>
              {" "}
              <ImageBackgroundWithCarousel
                images={
                  filteredImages.length > 0 ? filteredImages : activity.images
                }
                activity={activity}
              />{" "}
            </Box>
          )}
        </InlineDiv>
      </CustomDiv>
    </>
  );
};

export default ActivityMobileHeader;
